module.exports = __webpack_public_path__ + "img/user_management_off_icon.3442b74f.svg";